<template>

    <div  v-if="$store.getters.displayProductDetails1">
      <div>
        <div class="close"></div>
        <component
          :is="$store.getters.productDetailsActiveComponent"
        ></component>
      </div>
    </div>
 
</template>

<script>
import TButton from "../../../common/components/buttons/TButton.vue";
// import ProductDetailsContaint from "./HeaderProductDetailsContaint";
import { defineAsyncComponent } from 'vue'
const ProductDetailsContaint = defineAsyncComponent(() =>
  import('./HeaderProductDetailsContaint')
)
export default {
  components: { TButton },
  data() {
    return {};
  },
  created() {},
  // methods: {
  //   closeProductDetailsPopup() {
  //     this.$store.commit(
  //       "productDetailsActiveComponent",
  //       ProductDetailsContaint
  //     );
  //     this.$store.commit("displayProductDetails1", false);
  //   },
  // },
  props: {
    kitId: Number,
  },
};
</script>
<style lang="scss" scoped>



</style>
